import { css } from 'aphrodite';
import { Button } from '../../../../web/components-v2/Button';
import {
	Dialog,
	DialogBody,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogPopup,
	DialogTitle,
} from '../../../../web/components-v2/Dialog';
import { startDialogStyles } from './styles';

interface StartEventAutomationDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	count: number;
	includesOtherUsersContacts: boolean;
	isStarting: boolean;
	onConfirm: () => void;
}

export function StartEventAutomationDialog({
	open,
	onOpenChange,
	count,
	includesOtherUsersContacts,
	isStarting,
	onConfirm,
}: StartEventAutomationDialogProps) {
	return (
		<Dialog open={open} onOpenChange={next => !isStarting && onOpenChange(next)}>
			<DialogPopup styles={[startDialogStyles.popup]}>
				<DialogHeader>
					<DialogTitle>{`Start this automation for ${count} ${count === 1 ? 'person' : 'people'}?`}</DialogTitle>
					<DialogDescription>
						They&apos;ll get its emails from now on, and anything already due goes out right away.
					</DialogDescription>
				</DialogHeader>
				{includesOtherUsersContacts ? (
					<DialogBody>
						<p className={css(startDialogStyles.note)}>
							Some of these contacts belong to other users, so their emails will be sent as those users.
						</p>
					</DialogBody>
				) : null}
				<DialogFooter>
					<Button variant='outline' disabled={isStarting} onClick={() => onOpenChange(false)}>
						Cancel
					</Button>
					<Button isLoading={isStarting} disabled={isStarting} onClick={onConfirm}>
						Start automation
					</Button>
				</DialogFooter>
			</DialogPopup>
		</Dialog>
	);
}
